// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChatInputController from "./chat_input_controller"
application.register("chat-input", ChatInputController)

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MarkdownEditorController from "./markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import CopyToClipboardController from "./copy_to_clipboard_controller";
application.register("copy-to-clipboard", CopyToClipboardController);

import VegaLiteController from "./vega_lite_controller"
application.register("vega-lite", VegaLiteController)
